import api from "../apis/api";

class ActiveUsersService {
  getActiveUsers(req) {
    return api.activeUsers.getActiveUsers(req);
  }
}

export default new ActiveUsersService();
